import { styled } from "styled-components";
import { colors } from "@joinTrilo/ui/tokens";
import Card from "@joinTrilo/ui/atoms/Card";
import { typography } from "@joinTrilo/ui/tokens";

// The following styled layout elements are using some basic flex styles. To see them in action uncomment the background-color style
export const StyledContainer = styled.div`
    overflow: auto;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 100%;
    max-height: 100%;

    width: 100%;
    margin-left: auto;
    margin-right: auto;
    background-color: ${colors["lightestGrey"]};
`;

export const StyledOuter = styled.div`
    flex: 1;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 414px;
    width: 100%;
`;

export const StyledInner = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    max-height: 100%;
    padding: 0px 24px;
`;

export const StyledWarningBubble = styled(Card)`
    margin-top: 1.6rem;
    padding: 1.6rem;
    border: ${colors["warning"]} !important;
    font: ${typography.fonts.h6};
`;
